import type { FunctionComponent } from 'react';

export type LanguageSkillIconProps = {
    readonly isActive: boolean;
};

export const LanguageSkillIcon: FunctionComponent<LanguageSkillIconProps> = ({ isActive }) => {
    return (
        <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
            <rect fill={isActive ? '#FC531F' : '#1D272D'} height="6" width="12" y="3" />
        </svg>
    );
};
